import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { forkJoin, map, Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { RestaurantSlotTable, TableForSlot } from '../_models/RestaurantSlot';

@Injectable({
  providedIn: 'root',
})
export class SlotService {
  constructor(private apiService: ApiService) {}

  getTablesSlot(
    id_restaurant: string,
    id_restaurant_slot: string,
    form: FormGroup
  ): Observable<TableForSlot[]> {
    return forkJoin({
      restaurant: this.apiService.Restaurant(id_restaurant!),
      slot: this.apiService.Slot(id_restaurant!, id_restaurant_slot!),
    }).pipe(
      map(({ restaurant, slot }) => {
        form.patchValue({
          date: new Date(slot.slot_start),
          startTime: new Date(slot.slot_start),
          endTime: new Date(slot.slot_end),
          category: slot.category,
        });
        let restaurantSlotTables = slot.tables;
        return restaurant.tables.map((table) => {
          let selected = restaurantSlotTables.find(
            (t: RestaurantSlotTable) => t.fk_table == table.id_table
          );
          if (selected) {
            return {
              name: table.name,
              selected: true,
              myitalian: !!selected.myitalian,
              fk_table: table.id_table!,
              id_restaurant_slot_table: selected.id_restaurant_slot_table,
              fk_status: selected.fk_status,
              booked: !!selected.booked,
            };
          }
          return {
            name: table.name,
            selected: false,
            myitalian: false,
            fk_status: table.fk_status,
            fk_table: table.id_table!,
            booked: false,
          };
        });
      })
    );
  }
}
